module.exports = __webpack_public_path__ + "fonts/GeogrotesqueCyr-Regular.51f65617.eot";